<template>
  <div>
    <div style="margin-bottom: 10px;">
      <el-row>
        <el-col>
<!--          <el-button size="mini" @click="submit" v-if="form.house_id">保存</el-button>-->
          <erp-button size="mini" @click="submit" v-if="form.house_id">保存</erp-button>
          <el-button size="mini" @click="setComponentId('CustomerSaleChange')" v-if="form.house_id&&form.id">转让/退房</el-button>
<!--          <erp-button size="mini" v-if="form.house_id&&form.id" @click="cancelSale">撤销售楼</erp-button>-->
<!--          <el-button size="mini" @click="setComponentId('CustomerSaleHistory')" v-if="form.house_id&&form.id">历史业主</el-button>-->
<!--          <el-button size="mini" v-if="form.house_id" @click="toSaleCarryOver">账单结转历史</el-button>-->
        </el-col>
      </el-row>
    </div>
    <div>
      <span v-if="form.house_id&&form.id">当前有受让记录，换业主需要点击【转让/退房】，如果只是修改信息填写完后【保存】即可。</span>
      <span v-if="form.house_id&&!form.id">当前无受让记录，填写相关信息后点击【保存】即可。</span>
    </div>
    <el-descriptions size="mini" :column="1" border direction="vertical">
      <el-descriptions-item label="售楼详细信息">
        <el-descriptions size="mini" :label-style="{width: '100px'}" :column="2" border>
          <el-descriptions-item label-class-name="descriptions-label-class" label="业主名称">
            <el-input size="mini" disabled v-model="form.customer_name" class="w-200" placeholder="无受让记录"></el-input>
            <el-button size="mini" v-if="!(form.house_id&&form.id)" @click="selectUser">选择客户</el-button>
<!--            <el-button size="mini" icon="el-icon-user-solid" circle title="新增客户" v-if="!(form.house_id&&form.id)" @click="addCustomer(1)"></el-button>-->
<!--            <el-button size="mini" icon="el-icon-s-home" circle title="新增企业" v-if="!(form.house_id&&form.id)" @click="addCustomer(2)"></el-button>-->
            <el-button size="mini"  icon="el-icon-info" circle title="用户详情" @click="showEditor"></el-button>
          </el-descriptions-item>
          <el-descriptions-item label="主房产">
<!--            <el-input size="mini" v-model="form.house_address" class="w-200"></el-input>-->
            <el-autocomplete
              style="min-width: 400px;max-width: 100%"
              v-model="form.house_address"
              :fetch-suggestions="querySearchAsyncRoom"
              @select="handleSelect"
              placeholder="请输入房产"
              popper-class="autocomplete-room"
              clearable
            ></el-autocomplete>
<!--            <el-input size="mini" v-model="form.belong_house_id" class="w-200"></el-input> -->
          </el-descriptions-item>
          <el-descriptions-item label="合同编号">
            <el-input size="mini" v-model="form.contract_id" class="w-200"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="合同名称">
            <el-input size="mini" v-model="form.contract_name" class="w-200"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="认购日期">
            <el-date-picker
              v-model="form.book_date"
              type="date"
              size="mini"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
          </el-descriptions-item>
          <el-descriptions-item label="销售团队">
            <el-input size="mini" v-model="form.sales_team" class="w-200"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="首次签订日期">
            <el-date-picker
              v-model="form.contract_date"
              type="date"
              size="mini"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
            <span style="color: #ff3d00;margin-left: 10px;">必填</span>
          </el-descriptions-item>
          <el-descriptions-item label="签订日期">
            <el-date-picker
              v-model="form.new_contract_date"
              type="date"
              size="mini"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
            <span style="color: #ff3d00;margin-left: 10px;">必填</span>
          </el-descriptions-item>
          <el-descriptions-item label="合同起始日">
            <el-date-picker
              v-model="form.from_date"
              type="date"
              size="mini"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
          </el-descriptions-item>
          <el-descriptions-item label="许可证号">
            <el-input size="mini" v-model="form.license_id" class="w-200"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="合同截至日">
            <el-date-picker
              v-model="form.to_date"
              type="date"
              size="mini"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
          </el-descriptions-item>
          <el-descriptions-item label="交付使用日">
            <el-date-picker
              v-model="form.receive_date"
              type="date"
              size="mini"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
          </el-descriptions-item>
          <el-descriptions-item label="售价">
            <el-input size="mini" v-model="form.unit_price" class="w-200"></el-input>(元/平方米)
          </el-descriptions-item>
          <el-descriptions-item label="按揭放款日">
            <el-date-picker
              v-model="form.mortgage_fund_date"
              type="date"
              size="mini"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
          </el-descriptions-item>
          <el-descriptions-item label="付款方式">
            <el-select size="mini" v-model="form.pay_kind" placeholder="请选择" class="w-200">
              <el-option
                v-for="item in [{id:0,name:'---请选择---'},{id:1,name:'一次性付款'},{id:2,name:'按揭'},{id:3,name:'分期'}]"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="金额">
            <el-input size="mini" v-model="form.amount" class="w-200"></el-input>元
          </el-descriptions-item>
          <el-descriptions-item label="备注">
            <el-input size="mini" v-model="form.remarks" class="w-200"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="是否主房产">
            <!--        <el-input size="mini" v-model="form.owner_name" class="w-200"></el-input>-->
            <el-checkbox size="mini" v-model="form.is_main_house" label="(主房产用于邮寄帐单等)"></el-checkbox>
          </el-descriptions-item>
          <el-descriptions-item label="合同全文">
            <el-input size="mini" v-model="form.contract_text"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="是否出库" class="w-200">
            <!--        <el-input size="mini" v-model="form.owner_name"></el-input>-->
            <el-checkbox size="mini" v-model="form.is_out_store"></el-checkbox>
          </el-descriptions-item>
          <el-descriptions-item label="附件">
<!--            <UploadFileFJ :list="form.appendix||[]" @success="UploadFileFJSuccess" />-->
            <el-row>
              <el-col :span="12">
                <el-link type="primary" @click="$refs.viewFileListRef.UploadFile(data=>{form.file_id=data.FileID},form.file_id)">上传附件</el-link>
              </el-col>
              <el-col :span="12">
                <el-link type="primary" v-if="form.file_id" @click="$refs.viewFileListRef.show(form.file_id)">查看下载</el-link>
              </el-col>
            </el-row>
          </el-descriptions-item>
          <el-descriptions-item label="账单结转日期">
            <el-date-picker
              :disabled="!!form.id"
              v-model="form.billing_cut_off_date"
              type="date"
              size="mini"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
            <span style="color: #ff3d00;margin-left: 10px;">必填</span>
          </el-descriptions-item>


        </el-descriptions>
      </el-descriptions-item>
    </el-descriptions>
    <el-divider></el-divider>
    <el-card shadow="always">
      <p>1、当前如果没有受让记录的（无受让记录）,进入操作房产转让和订单结转！</p>
      <p>2、在操作完成后，业主将会直接切换为新业主！</p>
      <p>3、2025年8月开始，售楼登记将不再支持账单转结，有关账单转结需要联系 管家中心 操作！</p>
    </el-card>


    <AddCustomerWindow ref="AddCustomerWindow" />
    <editor v-model="editor.visable" :classValue="editor.classValue" :id="editor.id" :is_edit="false" @callback="editorCallback" />
    <ErpRoomUser ref="ErpRoomUser" />

    <CustomerSaleCarryOver ref="saleOver" />

    <ViewFileList ref="viewFileListRef" />

  </div>
</template>

<script>
import UploadFileFJ from "./UploadFileFJ";
import AddCustomerWindow from "../../Common/AddCustomerWindow";
import Editor from "../../Customer/editor";
import ErpRoomUser from "../../Common/ErpRoomUser";
import CustomerSaleCarryOver from "./components/CustomerSaleCarryOver";
import ErpButton from "../../Common/erp-ui/erp-button";
import ViewFileList from "../../Common/ViewFileList";
export default {
  name: "CustomerSaleMain",
  components: {ViewFileList, ErpButton, CustomerSaleCarryOver, ErpRoomUser, Editor, AddCustomerWindow, UploadFileFJ},
  data(){
    return {
      home_id:0,
      where:{},
      form:{
        customer_name:"",
        belong_house_id:"",
        contract_id:"",
        contract_name:"",
        book_date:"",
        sales_team:"",
        contract_date:"",
        new_contract_date:"",
        from_date:"",
        license_id:"",
        to_date:"",
        receive_date:"",
        unit_price:"",
        mortgage_fund_date:"",
        pay_kind:"",
        amount:"",
        remarks:"",
        is_main_house:true,
        contract_text:"",
        is_out_store:false,
        appendix:"",
        billing_cut_off_date:"",
      },
      editor:{
        classValue:1,
        id:0,
        visable:false
      },
      tableData:[]
    }
  },
  inject:['commonObj','setComponentId','componentId','mainObj'],
  watch:{
    "commonObj.house_id":function (n,o) {
      this.where={}
      this.where.house_id=n;
      this.commonObj.id&&(this.where.id=this.commonObj.id)
      this.componentId==='CustomerSaleMain'&&this.getData();
    },
    'commonObj.id':function (n,o) {
      this.where.id=n
    }
  },
  mounted() {
    this.where.house_id=this.commonObj.house_id;
    // this.where.house_id&&this.getData();
  },
  activated() {
    if(this.$route.query.houseid){
      this.where.house_id=this.$route.query.houseid;
    }
    this.where.house_id&&this.getData();
  },
  methods:{
    getData(){
      const that=this;
      let where=reObject(that.where)
      ERP.getRequest({
        url: "admin/HouseSale/get",
        data: {
          where: JSON.stringify(where),
        }
      }, res => {
        if (res.code) {
          let data=res.data;
          if(!data.house_id){
            data.house_id=data.ph_house_id;
            data.ph_house_id=undefined;
          }else {
            data.ph_house_id=undefined;
          }
          data.is_main_house=!!data.is_main_house;
          data.is_out_store=!!data.is_out_store;
          data.is_trans_customer_pre_payment=!!data.is_trans_customer_pre_payment;
          data.is_trans_pre_should_payment=!!data.is_trans_pre_should_payment;
          that.form=data
        }
      })
    },
    submit(evt,setLoading){
      const that=this;
      if(!that.form.customer_id){
        that.$message.error('选择用户')
        setLoading(false);
        return false;
      }
      if(!that.form.contract_date){
        that.$message.error('选择首次签订时间')
        setLoading(false);
        return false;
      }
      if(!that.form.new_contract_date){
        that.$message.error('选择签订时间')
        setLoading(false);
        return false;
      }
      if(!that.form.billing_cut_off_date){
        setLoading(false)
        that.$message.error('选择账单结转日期')
        return false;
      }
      if(!that.form.id){
        that.submit2(setLoading)
        return false;
      }
      let data=reObject(that.form)
      data.is_main_house=data.is_main_house?1:0;
      data.is_out_store=data.is_out_store?1:0;
      data.is_trans_customer_pre_payment=data.is_trans_customer_pre_payment?1:0;
      data.is_trans_pre_should_payment=data.is_trans_pre_should_payment?1:0;
      ERP.postRequest({
        url: "admin/HouseSale/save",
        data: data
      }, res => {
        if (res.code) {
          that.$message.success('修改成功')
          let data=res.data;
          data.is_main_house=!!data.is_main_house;
          data.is_out_store=!!data.is_out_store;
          data.is_trans_customer_pre_payment=!!data.is_trans_customer_pre_payment;
          data.is_trans_pre_should_payment=!!data.is_trans_pre_should_payment;
          that.form=data
        }
        setLoading(false);
      })
    },
    UploadFileFJSuccess(list){
      this.form.appendix=list;
    },
    addCustomer(type=1){
      const that=this;
      that.$refs.AddCustomerWindow.show(type,data=>{
        that.form.customer_id=data.customer_id;
        that.form.customer_name=data.name;
      })
    },
    showEditor() {
      const that=this;
      that.getCustomerBase(that.form.customer_id,data=>{
        that.editor.classValue = data.class
        that.editor.id = that.form.customer_id
        that.editor.visable = true
      })
    },
    getCustomerBase(customer_id,callback){
      ERP.getRequest({
        url: "admin/Customer/getCustomerBase",
        data: {
          id: customer_id,
        }
      }, res => {
        if (res.code) {
          typeof callback ==="function"&&callback(res.data);
        }
      })
    },
    editorCallback(arg) {
      // this.getList()
      if(arg && arg[0]) this.editor.id = arg[0]
    },
    selectUser(){
      const that=this;
      that.$refs.ErpRoomUser.show(data=>{
        if(!data.credentials_code){
          that.$message.error("请选择信息完善的客户,当前缺失证件号码！");
          return;
        }
        that.form.customer_id=data.id;
        that.form.customer_name=data.name;
      },"")
    },
    cancelSale(evt,setLoading){
      const that=this;
      that.$confirm('您再撤销前需要知道，撤销后将跳转向账单撤销（手动撤销）', '提示', {
        confirmButtonText: '下一步',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ERP.postRequest({url: "admin/HouseSale/cancelSale", data: {
            house_id:that.form.house_id
          }
        }, res => {
          if (res.code) {
            that.$message.success(res.msg)
            that.where.id=undefined;
            that.$confirm('您的售楼已经撤销成功，下面是进行费用结转撤销！', '提示', {
              confirmButtonText: '下一步',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              that.mainObj.new_customer_id=null;
              that.setComponentId("SaleCarryOver");
            }).catch(() => {
              that.$message.success("您已经选择放弃撤销费用结转！")
              that.getData()
            });
          }else {
            that.$message.error(res.msg||"操作失败")
          }
          setLoading(false)
        })
      }).catch(() => {

      });
    },
    submit2(setLoading){
      const that=this;
      if(!that.form.contract_date){
        that.$message.error('选择签订时间')
        setLoading(false)
        return false;
      }
      if(!that.form.customer_id){
        that.$message.error('选择新用户')
        setLoading(false)
        return false;
      }
      if(!that.form.billing_cut_off_date){
        that.$message.error('选择账单结转日期')
        setLoading(false)
        return false;
      }
      that.$confirm('您正在操作售楼登记，它会为更换该房产的业主，请确认操作！', '提示', {
        confirmButtonText: '下一步',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.submit1((status)=>{
          setLoading(false);
          status&&that.$message.success('请到【发起流程】处，发起流程审批');

          // that.$confirm('当前的业主已经更换，下一步将跳转进行账单结转！', '提示', {
          //   confirmButtonText: '下一步',
          //   cancelButtonText: '取消',
          //   type: 'warning'
          // }).then(() => {
          //   that.mainObj.old_customer_id="";
          //   that.mainObj.new_customer_id=that.form.customer_id;
          //   if(that.mainObj.new_customer_id){
          //     that.setComponentId("SaleCarryOver");
          //   }
          // }).catch(() => {
          //   that.$message.error('您当前放弃了账单结转')
          // });

          // that.isOrderStatus(that.commonObj.house_id,count=>{
          //   if(count>0){
          //     that.$refs.saleOver.show({
          //       house_id:that.where.house_id,
          //       house_sale_log_id:id,
          //       callback:function () {
          //         that.setComponentId("CustomerSaleMain");
          //       }
          //     })
          //   }else {
          //     that.setComponentId("CustomerSaleMain");
          //   }
          // });
        })
      }).catch(() => {
        setLoading(false)
        that.$message.error('您当前放弃了改换业主！')
      });

    },
    submit1(callback){
      const that=this;
      let form_2=reObject(that.form)
      ERP.postRequest({
        url: "admin/HouseSale/saveChangeOver",
        data: {
          project_id:that.mainObj.project_id,
          house_id:that.commonObj.house_id,
          form_1:"",
          form_2:JSON.stringify(form_2),
          meter_note_str:"",
          temp_flow:1
        }
      }, res => {
        if (res.code) {
          typeof callback==="function"&&callback(1);
        }else{
          that.$message.error(res.msg||"请求异常")
          typeof callback==="function"&&callback(0);
        }
      })
    },
    isOrderStatus(house_id,callback){
      ERP.getRequest({url: "admin/HouseSale/isOrderStatus", data: {
          house_id:house_id
        }
      }, res => {
        if (res.code) {
          typeof callback==="function"&&callback(res.data)
        }
      })
    },
    toSaleCarryOver(){
      const that=this;
      if(!that.mainObj.house_id){
        that.$message.error('请选择房产');
        return false;
      }
      that.setComponentId("SaleCarryOver")
    },
    querySearchAsyncRoom(queryString, cb){
      if(!queryString){
        cb([]);
      }else {
        ERP.postRequest({
          url:"admin/Customer/getHouseList",
          data:{keyWord:queryString}
        },ret=>{
          if(ret.code) {
            cb(ret.data)
          }
        })
      }
    },
    handleSelect(item) {
      this.commonObj.house_id=item.id;
      this.mainObj.house_id=item.id;
      this.mainObj.house_name=item.value;
      this.mainObj.project_id=item.project_id;
    },
  }
}
function reObject(item) {
  return JSON.parse(JSON.stringify(item));
}
</script>

<style lang="scss" scoped>
.autocomplete-room{
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/User/CustomerManagement/CustomerSaleMain.vue